__turbopack_context__.v({
  "chevron": "NavDropdown-module-scss-module__1RSSra__chevron",
  "container": "NavDropdown-module-scss-module__1RSSra__container",
  "open": "NavDropdown-module-scss-module__1RSSra__open",
});
